module.exports = __webpack_public_path__ + "media/claim/assets/images/right_panel/money_200_usd-4623230e9673e296de60ad6d3a3969b8.png";